/**
 * 멤버십 상품 구성 설정
 * - 가격, 문구, 링크 변경 시 이 파일만 수정하면 됩니다.
 *
 * [프로모션 여러 개 운영 방법]
 * 1. 기간이 연이어 이어지는 경우 → PROMOTIONS에 각각 start/end 등록 (동시에 1개만 활성)
 * 2. 프로모션마다 가격/문구가 다를 때 → 상품 필드에 프로모션 ID를 키로 지정
 *    예: bonusDesc: { default: '...', '260709': '...', '260715': '...' }
 * 3. 여러 프로모션이 같은 혜택일 때 → PROMOTIONS.campaignId 값을 상품 필드 키로 지정
 *    예: bonusDesc: { default: '...', '2026-summer': '加赠9个月' }
 *    (우선순위: 프로모션 title → campaignId → promotion → default)
 * 4. 구매 링크도 동일 — link: { default: '...', '2026-summer': '...', '260720': '...' }
 */

/** PROMOTIONS.campaignId 와 동일한 키 — 여러 프로모션 기간에 공통 적용 */
const CAMPAIGN_2026_SUMMER = '2026-summer'
//const CAMPAIGN_2026_JULY = '2026-july'

export const PROMOTIONS = [
    {
        title: '260627',
        campaignId: '2026-summer',
        start: '2026-06-27 01:00:00',
        end: '2026-07-13 01:00:00',
        bannerTitle: '轻松不费妈 英语快乐GO',
        showGift: true,
        periodDesc: '（仅6月27日-7月12日期间）'
    },
    {
        title: '260720',
        campaignId: '2026-summer',
        start: '2026-07-20 01:00:00',
        end: '2026-08-11 01:00:00',
        bannerTitle: '轻松不费妈 英语快乐GO',
        showGift: true,
        periodDesc: ' (仅7月20日-8月10日期间) '
    }
    // 연속 프로모션 예시:
    // {
    //     title: '260709',
    //     campaignId: '2026-july',
    //     start: '2026-07-09 01:00:00',
    //     end: '2026-07-14 01:00:00',
    //     bannerTitle: '7月特惠',
    //     periodDesc: '（仅7月9日-7月13日期间）'
    // },
    // {
    //     title: '260715',
    //     campaignId: '2026-july',   ← PROMOTIONS.campaignId 와 동일
    //     ...
    // },
    // 상품 필드 예시 (2026-july 캠페인 3주 연속, 혜택 동일):
    // bonusDesc: { default: '加贈12个月', '2026-july': '加赠9个月' }
    // 주차별로 다르면:
    // bonusDesc: { default: '加贈12个月', '2026-july': '加赠9个月', '260715': '加赠8个月' }
]

const SUBTITLE = '(2个孩子使用)'

const GIFT_SUB_DESC = '送Orchard Toys配对和拼写1盒'

/** 프로모션(기본) 상품 — 2행 × 2열 */
export const PROMOTION_PRODUCT_ROWS = [
    [
        {
            title: '2年卡',
            subtitle: SUBTITLE,
            originalPrice: '1188',
            discountPrice: '988',
            discountPriceInValueSpan: true,
            // campaignId 키: 260627·260720 등 '2026-summer' 캠페인 공통 혜택
            bonusDesc: {
                default: '加贈12个月',
                [CAMPAIGN_2026_SUMMER]: '加赠9个月'
                // 특정 프로모션만 다를 때 title 키 추가 (campaignId보다 우선)
                //[CAMPAIGN_2026_JULY]: '加赠10个月'
            },
            subDesc: {
                default: '',
                [CAMPAIGN_2026_SUMMER]: GIFT_SUB_DESC
            },
            link: {
                [CAMPAIGN_2026_SUMMER]: 'https://sourl.co/m4fpd9'
                // '260720': 'https://...',
            },
            badge: 'badge-200',
            noPadding: true
        },
        {
            title: '1年卡',
            subtitle: SUBTITLE,
            originalPrice: '899',
            discountPrice: '699',
            discountPriceInValueSpan: true,
            bonusDesc: { default: '加贈9个月', [CAMPAIGN_2026_SUMMER]: '加赠6个月' },
            subDesc: { default: '', [CAMPAIGN_2026_SUMMER]: GIFT_SUB_DESC },
            link: {
                [CAMPAIGN_2026_SUMMER]: 'https://sourl.co/LDXP6m'
            },
            badge: 'badge-200'
        }
    ],
    [
        {
            title: '半年卡',
            subtitle: SUBTITLE,
            originalPrice: '680',
            discountPrice: { default: '580', [CAMPAIGN_2026_SUMMER]: '480' },
            bonusDesc: { default: '加赠1个月', [CAMPAIGN_2026_SUMMER]: '加赠6个月' },
            subDesc: { default: '(每个孩子 0.75/天)', [CAMPAIGN_2026_SUMMER]: GIFT_SUB_DESC },
            link: {
                [CAMPAIGN_2026_SUMMER]: 'https://shop91489875.m.youzan.com/wscgoods/detail/3nfq9e1q7aoq3?scan=1&activity=none&from=kdt&qr=directgoods_888245981&shopAutoEnter=1'
            },
            badge: 'placeholder'
        },
        {
            title: '7日卡',
            subtitle: SUBTITLE,
            originalPrice: '32',
            discountPrice: '9.9',
            bonusDesc: '',
            bonusDescHidden: true,
            subDesc: '仅限新用户购买',
            link: {
                [CAMPAIGN_2026_SUMMER]: 'https://shop91489875.m.youzan.com/wscgoods/detail/2omys8klrnxyjui?scan=1&activity=none&from=kdt&qr=directgoods_4095495506&shopAutoEnter=1'
            },
            badge: 'blank',
            badgeText: '新用户<br>专享',
            alwaysShowOriginalPrice: true,
            headerLeftAlign: true
        }
    ]
]

/** 뷰 타입별 상품 구성 */
export const VIEW_PRODUCTS = {
    membership: {
        title: '续费专用',
        desc: ['减轻压力 续航学习时间!'],
        products: [
            {
                title: '2年卡',
                subtitle: SUBTITLE,
                originalPrice: '988',
                discountPrice: '688',
                priceDesc: '（每个孩子 0.4/天）',
                subDesc: '下单后请联络官方开通',
                link: 'https://shop91489875.m.youzan.com/wscgoods/detail/3f1xxe0cueajfjp?scan=1&activity=none&from=kdt&qr=directgoods_3801584580&shopAutoEnter=1'
            },
            {
                title: '1年卡',
                subtitle: SUBTITLE,
                originalPrice: '699',
                discountPrice: '399',
                priceDesc: '（每个孩子 0.55/天）',
                subDesc: '下单后请联络官方开通',
                link: 'https://shop91489875.m.youzan.com/wscgoods/detail/2x5pjcgc3ahhnw2?scan=1&activity=none&from=kdt&qr=directgoods_2878500740&shopAutoEnter=1'
            },
            {
                title: '半年卡',
                subtitle: SUBTITLE,
                originalPrice: '580',
                discountPrice: '309',
                priceDesc: '（每个孩子 0.88天）',
                subDesc: '下单后请联络官方开通',
                link: 'https://shop91489875.m.youzan.com/wscgoods/detail/3evqn19n4b18b0a?scan=1&activity=none&from=kdt&qr=directgoods_5518885667&shopAutoEnter=1'
            }
        ]
    },
    new: {
        title: '新注册专项',
        desc: ['注册7日内下单, ', '立减 ¥100!'],
        products: [
            {
                title: '2年卡',
                subtitle: SUBTITLE,
                originalPrice: '988',
                discountPrice: '888',
                bonusDesc: '24个月 +赠9个月',
                subDesc: '（每个孩子 0.45/天）',
                badge: 'badge-100',
                headerLeftAlign: true,
                link: 'https://shop91489875.m.youzan.com/wscgoods/detail/35y9nwlad0dq38j?scan=1&activity=none&from=kdt&qr=directgoods_3801576448&shopAutoEnter=1'
            },
            {
                title: '1年卡',
                subtitle: SUBTITLE,
                originalPrice: '699',
                discountPrice: '599',
                bonusDesc: '12个月 +赠6个月',
                subDesc: '（每个孩子 0.55/天）',
                badge: 'badge-100',
                headerLeftAlign: true,
                link: 'https://shop91489875.m.youzan.com/wscgoods/detail/3npjt5comlz2zh4?scan=1&activity=none&from=kdt&qr=directgoods_3801584756&shopAutoEnter=1'
            },
            {
                title: '半年卡',
                subtitle: SUBTITLE,
                originalPrice: '580',
                discountPrice: '480',
                bonusDesc: '6个月 +赠5个月',
                subDesc: '（每个孩子 0.72/天）',
                badge: 'badge-100',
                headerLeftAlign: true,
                link: 'https://shop91489875.m.youzan.com/wscgoods/detail/27cx3zxwqjr5727?scan=1&activity=none&from=kdt&qr=directgoods_2878500615&shopAutoEnter=1'
            }
        ]
    },
    all: {
        productsClass: 'no-title',
        products: [
            {
                title: '2年卡',
                subtitle: SUBTITLE,
                discountPrice: '988',
                bonusDesc: '加赠9个月',
                subDesc: '（每个孩子0.49/天）',
                headerLeftAlign: true,
                link: 'https://shop91489875.m.youzan.com/wscgoods/detail/1yj55vk0h4pfv?scan=1&activity=none&from=kdt&qr=directgoods_875457606&shopAutoEnter=1'
            },
            {
                title: '1年卡',
                subtitle: SUBTITLE,
                discountPrice: '699',
                bonusDesc: '加赠6个月',
                subDesc: '（每个孩子0.64/天）',
                headerLeftAlign: true,
                link: 'https://shop91489875.m.youzan.com/wscgoods/detail/1ye8ngkc8qm2j?scan=1&activity=none&from=kdt&qr=directgoods_888303865&shopAutoEnter=1'
            },
            {
                title: '半年卡',
                subtitle: SUBTITLE,
                discountPrice: '580',
                bonusDesc: '加赠5个月',
                subDesc: '（每个孩子0.87/天）',
                headerLeftAlign: true,
                link: 'https://shop91489875.m.youzan.com/wscgoods/detail/3nfq9e1q7aoq3?scan=1&activity=none&from=kdt&qr=directgoods_888245981&shopAutoEnter=1'
            },
            {
                title: '7日卡',
                subtitle: SUBTITLE,
                originalPrice: '32',
                discountPrice: '9.9',
                bonusDesc: '',
                bonusDescHidden: true,
                subDesc: '仅限新用户购买',
                badge: 'blank',
                badgeText: '新用户<br>专享',
                headerLeftAlign: true,
                link: 'https://shop91489875.m.youzan.com/wscgoods/detail/2omys8klrnxyjui?scan=1&activity=none&from=kdt&qr=directgoods_4095495506&shopAutoEnter=1'
            }
        ]
    }
}

/** { default, promotion, [promotionId], [campaignId] } 형태 또는 단일 값을 컨텍스트에 맞게 해석 */
function resolveValue(value, context) {
    if (value == null) return ''
    if (typeof value !== 'object' || Array.isArray(value)) return value

    const { promotionId, campaignId } = context
    const isPromotion = promotionId !== 'membership'

    if (isPromotion && promotionId && value[promotionId] != null) {
        return value[promotionId]
    }
    if (isPromotion && campaignId && value[campaignId] != null) {
        return value[campaignId]
    }
    if (isPromotion && value.promotion != null) {
        return value.promotion
    }
    return value.default ?? ''
}

/** 상품 설정을 렌더링용 객체로 변환 */
export function resolveProduct(product, context) {
    const { promotionId, showBadge, showOriginalPrice } = context
    const isPromotion = promotionId !== 'membership'
    const hasConditionalBadge = product.badge && product.badge !== 'blank' && product.badge !== 'placeholder'
    const showProductBadge = product.badge === 'blank'
        || (product.badge === 'placeholder' && showBadge)
        || (hasConditionalBadge && showBadge)

    return {
        title: product.title,
        subtitle: product.subtitle,
        originalPrice: product.alwaysShowOriginalPrice || showOriginalPrice
            ? product.originalPrice
            : null,
        discountPrice: resolveValue(product.discountPrice, context),
        discountPriceInValueSpan: product.discountPriceInValueSpan ?? false,
        bonusDesc: resolveValue(product.bonusDesc, context),
        bonusDescHidden: product.bonusDescHidden ?? false,
        priceDesc: product.priceDesc ?? '',
        subDesc: resolveValue(product.subDesc, context),
        showSubDesc: product.subDesc != null,
        subDescColored: isPromotion && !!resolveValue(product.subDesc, context),
        badge: product.badge ?? null,
        badgeText: product.badgeText ?? '',
        showBadge: showProductBadge,
        headerLeftAlign: product.headerLeftAlign ?? showProductBadge,
        noPadding: product.noPadding ?? false,
        link: resolveValue(product.link, context)
    }
}

export function resolveProductRows(rows, context) {
    return rows.map((row) => row.map((product) => resolveProduct(product, context)))
}

export function resolveProducts(products, context) {
    return products.map((product) => resolveProduct(product, context))
}

export function getActivePromotion(promotionId) {
    return PROMOTIONS.find((p) => p.title === promotionId) || null
}

/** 서버 시각 기준 현재 활성 프로모션 ID 탐색 */
export function findActivePromotionId(servertime, moment, options = {}) {
    if (!servertime) return 'membership'

    const { isProduction = true, testQuery = null } = options
    const now = moment(servertime)
    let promotionId = 'membership'

    for (const p of PROMOTIONS) {
        const checkStart = now.isAfter(moment(p.start))
        const checkEnd = now.isBefore(moment(p.end))

        if (
            isProduction && checkStart && checkEnd
            || !isProduction && checkEnd
        ) {
            promotionId = p.title
            break
        }
    }

    if (!isProduction && testQuery) {
        if (testQuery === 'normal') {
            return 'membership'
        }
        if (PROMOTIONS.find((p) => p.title === testQuery)) {
            return testQuery
        }
    }

    return promotionId
}

export function buildProductContext(promotionId) {
    const activePromotion = getActivePromotion(promotionId)
    const isActivePromotion = promotionId !== 'membership'

    return {
        promotionId,
        campaignId: activePromotion?.campaignId || null,
        showBadge: !isActivePromotion,
        showOriginalPrice: !isActivePromotion
    }
}
